<template>
    <teleport to="head">
        <meta name="title" content="Writing | Projects"/>
        <meta name="description" content="Writing about my projects, computer science topics, and maybe a tutorial here and there."/>
        <link rel="canonical" href="https://brandonaguirre.com/writing">
    </teleport>
    <div class="banner">
        <h1>Here's what I've been up to lately</h1>
    </div>
    <div class="photo-shelf-outer-wrap">
        <div class="photo-shelf-inner-wrap">
            <photo-shelf style="margin: 0">
                <template v-for="entry in selectedEntries" :key="entry.slug">
                    <blog-card
                        class="frame"
                        :src="entry.cover_img"
                        :text="entry.description"
                        :tags="entry.tags"
                        :date="formatDate(entry.date)"
                        :link="getLink(entry)"
                    />
                </template>
            </photo-shelf>
        </div>
    </div>
</template>

<script>
    import PhotoShelf from '@/components/PhotoShelf'
    import BlogCard from '@/components/BlogCard'
    import formatDate from '@/helpers/formatDate'

    // Aggregate every post's front matter WITHOUT bundling the article bodies:
    // the `!!` inline loader bypasses the configured .md chain and runs only the
    // front-matter-only loader, so each entry here is just a metadata object.
    function loadEntries () {
        const ctx = require.context('!!../../mdFrontmatterLoader.js!../markdown', false, /\.md$/)
        return ctx.keys().map(key => {
            const frontmatter = ctx(key).default
            const slug = key.replace(/^\.\//, '').replace(/\.md$/, '')
            return { ...frontmatter, slug }
        })
    }

    export default {
        name: "BlogProjectsSingle",
        components: {
            PhotoShelf,
            BlogCard
        },
        data () {
            return {
                entries: loadEntries(),
                filterOptions: ['All', 'Projects', 'Blog'],
                selectedFilter: 1,
            }
        },
        computed: {
            sortedEntries () {
                return [...this.entries].sort((a, b) => {
                    const ap = a.priority ? a.priority : Number.POSITIVE_INFINITY
                    const bp = b.priority ? b.priority : Number.POSITIVE_INFINITY
                    return ap < bp ? -1 : 1
                })
            },
            blogs () { 
                return this.sortedEntries.filter(entry => entry.type == 'blog')
            },
            projects () {
                return this.sortedEntries.filter(entry => entry.type == 'project')
            },
            selectedEntries () {
                let entries = [...this.sortedEntries]
                if (this.selectedFilter == 1) {
                    entries = this.projects
                } else if (this.selectedFilter == 2) {
                    entries = this.blogs
                }
                return entries
            }
        },
        methods: {
            formatDate,
            getLink (entry) {
                if (entry.external_link) return entry.external_link
                return '/writing/' + entry.slug
            }
        }
    }
</script>

<style scoped lang="scss">
    .banner {
        position: relative;
        z-index: 1;
        height: 300px;
        border-bottom: #dddddd 1px solid;
        box-shadow: 0 0 2px 1px rgb(0 0 0 / 20%);

        display: flex;
        justify-content: center;
        align-items: center;

        h1 {
            text-align: center;
            position: absolute;
            margin: 0;
            font-size: 3rem;
            padding: 15px;
        }
    }
    .photo-shelf-outer-wrap {
        background: #fafafa;
    }
    .photo-shelf-inner-wrap {
        max-width: 1000px;
        margin: auto;
        padding: 20px 10px 50px 10px;
    }
</style>